import $ from 'jquery';
import { TweenMax, TimelineLite } from 'gsap';
import { salvarTamanho } from './TamanhoSalvo';

var TamanhoSetas = {};
TamanhoSetas.elems = {};

$(document).ready(function() {
  TamanhoSetas.elems.rightArrow = $('.tamanho-seta-direita');
  TamanhoSetas.elems.leftArrow = $('.tamanho-seta-esquerda');
})

TamanhoSetas.enable = function() {
  // console.log('enable');
  TamanhoSetas.elems.rightArrow.fadeIn();
  TamanhoSetas.elems.leftArrow.fadeIn();
};

TamanhoSetas.enableRight = function() {
  // console.log('enableRight');
  TamanhoSetas.elems.rightArrow.fadeIn();
  TamanhoSetas.elems.leftArrow.fadeOut();
};

TamanhoSetas.enableLeft = function() {
  // console.log('enableLeft');
  TamanhoSetas.elems.rightArrow.fadeOut();
  TamanhoSetas.elems.leftArrow.fadeIn();
};

TamanhoSetas.disable = function() {
  // console.log('disable');
  TamanhoSetas.elems.leftArrow.fadeOut();
  TamanhoSetas.elems.rightArrow.fadeOut();
};

TamanhoSetas.setLeftCallback = function(cb) {
  // TamanhoSetas._leftCallback = cb;
  TamanhoSetas.elems.leftArrow.off('click').on('click', cb);
};
TamanhoSetas.setRightCallback = function(cb) {
  // TamanhoSetas._rightCallback = cb;
  TamanhoSetas.elems.rightArrow.off('click').on('click', cb);
};


function TamanhoTabs(selector) {
  this.elems = {};
  this.elems.root = $(selector);
  this.elems.tabs = [];
  this.elems.targets = this.elems.root.find('.tamanho-target');

  this.initTabs();
}

TamanhoTabs.prototype.initTabs = function initTabs() {
  this.elems.tabs = [];
  let self = this;

  let leTabs = this.elems.root.find('[data-tamanho-tab]');
  let btnComprar = this.elems.root.find('[data-modalcompra-open]');

  let setTab = function(tab, target) {
    leTabs.removeClass('active');
    tab.addClass('active');
    // console.log('tab: ', tab);
    self.elems.targets.hide();
    target.fadeIn(1000);

    let tabCompraData = tab.data('btn-compra');
    // console.log('setTab::: ', tabCompraData, btnComprar);
    if(tabCompraData /*&& btnComprar.length*/) {
      btnComprar.attr('data-modalcompra-open', tabCompraData);
      $('[data-modalcompra-open]:not(.clique_comprar_superior)').attr('data-modalcompra-open', tabCompraData);
    }
  };

  leTabs.each(function(index) {
    let tab = $(this);
    let target = $(tab.data('tamanho-tab'));
    self.elems.tabs.push(tab);
    
    let tamanhoAnimadoElem = target.find('.tamanho-animado');
    let tamanhoAnimado = null;
    if(tamanhoAnimadoElem.length) {
      tamanhoAnimado = new TamanhoAnimado(tamanhoAnimadoElem);
    }

    // console.log('tamanhoAnimado: ', tamanhoAnimado)

    tab.click(() => {
      // console.log('open tab ', tamanhoAnimado);
      if(tamanhoAnimado) tamanhoAnimado.animate();
      setTab(tab, target);
    });
  });

  // setTab($(leTabs[0]));
  $(leTabs[0]).click();
};













function TamanhoAnimado(elem) {
  this.elems = {};
  this.elems.root = $(elem);
  this.elems.imgs = this.elems.root.find('[data-img]');
  this.imgcount = this.elems.imgs.length;
  this.isMobile = $(window).width() < 800;
  // this.isMobile = true;

  this.render();
  this.initMobile();
}

TamanhoAnimado.prototype.render = function() {
  let templateImg = '<div class="tamanho-img-img" style="background-image:url(\':imgurl\')"></div>';
  // let templateLabel = '<div class="tamanho-img-label"><span class="pct">:name</span> <span class="qtd">:qtd</span> <span class="un">unidades</span></div>';
  let templateLabel = '<div class="tamanho-img-label" style="background-image:url(\':lblurl\')"></div>';

  this.elems.root.addClass('com-' + this.imgcount);

  this.elems.imgs.each(function(index) {
    let elImg = $(this);
    let imgUrl = elImg.attr('data-img');
    // let labelQtd = elImg.attr('data-qtd') || '';
    // let labelName = elImg.attr('data-name') || '';
    let labelUrl = elImg.attr('data-etiqueta');

    let html = templateImg.replace(':imgurl', imgUrl);
    // if(labelQtd || labelName) html += templateLabel.replace(':qtd', labelQtd).replace(':name', labelName || '&nbsp;');
    if(labelUrl) html += templateLabel.replace(':lblurl', labelUrl);

    elImg.html(html);
  });
};

TamanhoAnimado.prototype.animate = function() {
  // this.reset();
  
  // TweenMax.set(this.elems.root, {
  //   opacity: 1,
  // });

  if(this.isMobile) {
    if(this.imgcount === 1) {
      TamanhoSetas.disable();
    } else if(this.imgcount > 1) {
      TamanhoSetas.enableRight();
    }

    if(this.imgcount === 1) {
      TweenMax.to(this.elems.imgs[0], 1, {
        opacity: 1,
      });
    } else if(this.imgcount === 2) {
      TweenMax.to(this.elems.imgs[0], 1, {
        opacity: 1,
      });
      TweenMax.to(this.elems.imgs[1], 1.3, {
        opacity: 1,
      });
    } else if(this.imgcount === 3) {
      // console.log('ANIMANDO: ', this.elems.imgs[0]);
      TweenMax.to(this.elems.imgs[0], 1, {
        opacity: 1,
      });
      TweenMax.to(this.elems.imgs[1], 1.6, {
        opacity: 1,
      });
      TweenMax.to(this.elems.imgs[2], 1.3, {
        opacity: 1,
      });
    }
  } else {
    if(this.imgcount === 1) {
      TweenMax.to(this.elems.imgs[0], 1, {
        marginTop: 0,
        opacity: 1,
      });
    } else if(this.imgcount === 2) {
      TweenMax.to(this.elems.imgs[0], 1, {
        marginLeft: 0,
        opacity: 1,
      });
      TweenMax.to(this.elems.imgs[1], 1.3, {
        marginLeft: 0,
        opacity: 1,
      });
    } else if(this.imgcount === 3) {
      // console.log('ANIMANDO: ', this.elems.imgs[0]);
      TweenMax.to(this.elems.imgs[0], 1, {
        marginLeft: 0,
        opacity: 1,
      });
      TweenMax.to(this.elems.imgs[1], 1.6, {
        marginTop: 0,
        opacity: 1,
      });
      TweenMax.to(this.elems.imgs[2], 1.3, {
        marginLeft: 0,
        opacity: 1,
      });
    }
  }
};

// TamanhoAnimado.prototype.reset = function() {
//   // TweenMax.set(this.elems.root, {
//   //   opacity: 0,
//   // });

//   if(this.isMobile) {
//     if(this.imgcount === 1) {
//       TweenMax.set(this.elems.imgs[0], {
//         opacity: 0,
//       });
//     } else if(this.imgcount === 2) {
//       TweenMax.set(this.elems.imgs[0], {
//         opacity: 0,
//       });
//       TweenMax.set(this.elems.imgs[1], {
//         opacity: 0,
//       });
//     } else if(this.imgcount === 3) {
//       TweenMax.set(this.elems.imgs[0], {
//         opacity: 0,
//       });
//       TweenMax.set(this.elems.imgs[1], {
//         opacity: 0,
//       });
//       TweenMax.set(this.elems.imgs[2], {
//         opacity: 0,
//       });
//     }
//   } else {
//     if(this.imgcount === 1) {
//       TweenMax.set(this.elems.imgs[0], {
//         marginTop: '-50px',
//         opacity: 0,
//       });
//     } else if(this.imgcount === 2) {
//       TweenMax.set(this.elems.imgs[0], {
//         marginLeft: '-50px',
//         opacity: 0,
//       });
//       TweenMax.set(this.elems.imgs[1], {
//         marginLeft: '50px',
//         opacity: 0,
//       });
//     } else if(this.imgcount === 3) {
//       TweenMax.set(this.elems.imgs[0], {
//         marginLeft: '-50px',
//         opacity: 0,
//       });
//       TweenMax.set(this.elems.imgs[1], {
//         marginTop: '-50px',
//         opacity: 0,
//       });
//       TweenMax.set(this.elems.imgs[2], {
//         marginLeft: '50px',
//         opacity: 0,
//       });
//     }
//   }
// };

TamanhoAnimado.prototype.initMobile = function initMobile() {
  if(!this.isMobile) return;
  let self = this;
  
  let isMoving = false;

  self.elems.imgs.hide();
  $(self.elems.imgs[0]).show();

  let stopMoving = () => {
    isMoving = false;
  };

  self.elems.imgs.each(function(index) {
    let imgLength = self.elems.imgs.length;
    let elImg = $(this);
    let mc = new Hammer(this);
    mc.get('pan').set({ threshold: 100, direction: Hammer.DIRECTION_HORIZONTAL });

    let rightCallback = () => {
      if(!isMoving) {
        console.log('rightCallback ', index, imgLength);
        if(index < imgLength - 1) {
          isMoving = true;
          let elNext = self.elems.imgs[index+1];
          TweenMax.set(elImg, { position: 'absolute' });
          TweenMax.set(elNext, { display: 'block', opacity: 0 });
          new TimelineLite()
            .to(elImg, .4, { left: '-100%', opacity: 0 })
            .fromTo(elNext, .4, { left: '100%', opacity: 0 }, { left: '0%', opacity: 1, delay: -.25 })
          setTimeout(stopMoving, 500);
        }
        if(imgLength > 1) {
          if(index === imgLength - 2) {
            TamanhoSetas.enableLeft();
          } else {
            TamanhoSetas.enable();
          }
        } else {
          TamanhoSetas.disable();
        }
      }
    };

    let leftCallback = () => {
      if(!isMoving) {
        console.log('leftCallback');
        if(index > 0) {
          isMoving = true;
          let elPrev = self.elems.imgs[index-1];
          TweenMax.set(elImg, { position: 'absolute' });
          TweenMax.set(elPrev, { display: 'block', opacity: 0 });
          new TimelineLite()
            .to(elImg, .5, { left: '100%', opacity: 0 })
            .fromTo(elPrev, .5, { left: '-100%', opacity: 0 }, { left: '0%', opacity: 1, delay: -.25 })
          setTimeout(stopMoving, 500);
        }
        if(imgLength > 1) {
          if(index === 1) {
            TamanhoSetas.enableRight();
          } else {
            TamanhoSetas.enable();
          }
        } else {
          TamanhoSetas.disable();
        }
      }
    };

    mc.on('panleft', () => rightCallback());
    mc.on('panright', () => leftCallback());
  });
};







$(document).ready(function() {
  $('[data-tamanho-tabs]').each(function() {
    new TamanhoTabs(this);
  });
  $('[data-tamanho-set]').click(function() {
    let tamanho = $(this).data('tamanho-set');
    salvarTamanho(tamanho);
  });
});
